/**
 * This hook gets the count of selected devices from the
 * legacy device list.
 */
export default function useSelectedDevices(): LegacyDevice[] {
  if (!window.getSelectedDevices) return []
  return window.getSelectedDevices()
}
